var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2",attrs:{"elevation":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }